<template>
  <div class="home-index-main" :style="{ color: textColor }">
    <div v-if="enableDashboard == null"></div>
    <DashboardMain v-else-if="enableDashboard" />
    <div v-else class="default-text">
      <img :src="logo" />
      <div>Welcome to DSM 6G web application</div>
      <div>Please navigate yourself through the application using the left menu bar</div><br />
      <div
        >If you have not configured your landing page, you can do it
        <router-link :to="{ path: `/Home/${userParam}/Settings/User Options` }">here</router-link></div
      >
    </div>
  </div>
</template>

<script>
import DashboardMain from '../../components/dashboard/DashboardMain.vue';
import { dashboardSasEnabled } from '../../components/dashboard/dashboardItemConfig';

/* eslint-disable */
export default {
  components: {
    DashboardMain,
  },
  data: function () {
    return {
      userParam: '',
      textColor: 'rgb(0,0,0)',

      enableDashboard: null,
    };
  },
  computed: {
    backgroundColor() {
      return this.$store.state.backgroundColor;
    },
    logo() {
      return this.$store.state.loginDetails?.['CoLogo'] ?? '';
    },
  },
  props: {},
  methods: {
    calculateTextColor: function (color) {
      color = color.replace('#', '');
      if (color.length == 3) {
        color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
      }

      var r = parseInt(color.slice(0, 2), 16);
      var g = parseInt(color.slice(2, 4), 16);
      var b = parseInt(color.slice(4, 6), 16);

      if ((r + g + b) / 3 > 100) {
        this.textColor = 'black';
      } else {
        this.textColor = 'white';
      }
    },

    async getDashboardAccess() {
      if (!dashboardSasEnabled) {
        this.enableDashboard = true;
        return;
      }

      const result = await this.$apiCallV2('/Dashboard/GetDashboardAccess', { control: 'DashboardWidget' });
      if (this._isDestroyed) return;
      if (!result || result?.[0]?.Results == '1' || result.length < 1) {
        this.enableDashboard = false;
        return;
      }
      this.enableDashboard = result.length > 0;
    },
  },
  mounted() {
    this.userParam = this.$route.params['user'];
    this.getDashboardAccess();
  },
  watch: {
    backgroundColor: {
      immediate: true,
      handler(color) {
        this.calculateTextColor(color);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.home-index-main {
  width: 100%;
  overflow: auto;
  > * {
    padding: 12px 16px 12px 50px;
  }

  .default-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 50px;
    width: 100%;

    > img {
      margin-top: 50px;
    }
  }
}
</style>
